import { render, staticRenderFns } from "./successPage.vue?vue&type=template&id=23195b14"
import script from "./successPage.vue?vue&type=script&lang=js"
export * from "./successPage.vue?vue&type=script&lang=js"
import style0 from "./successPage.vue?vue&type=style&index=0&id=23195b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports